/**
 * Created by fengc on 2020/03/16.
 */
import React, { Component } from "react";
import * as Helper from "../../utils/Helper";
import PropTypes from "prop-types";
import { StyleSheet, View } from "react-native";
import Word from "./Word";
import { Text } from "native-base";
import { EnumHasFlag, GetSentenceStyleBySentenceCommand, ParseSetting } from "../../utils/MarkTextHelper";
import Constants from "../../config/Constants";
import _ from "lodash";

class Sentence extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 0,
            curWord: -1,
            curChar: -1,
        };
        this._step = 0;
        this._length = 0;
    }

    componentDidMount() {
        if (this.props.duration > 0) {
            this.setupTimer();
        }
    }

    componentWillUnmount() {
        this.clearTimer();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.step !== nextState.step) {
            return true;
        }

        if (this.state.curWord !== nextState.curWord) {
            return true;
        }

        if (this.state.curChar !== nextState.curChar) {
            return true;
        }

        if (this.props.data !== nextProps.data && (!_.isEqual(this.props.data, nextProps.data))) {
            return true;
        }

        if (this.props.duration !== nextProps.duration) {
            return true;
        }

        if (this.props.progressColor !== nextProps.progressColor) {
            return true;
        }

        if (this.props.style !== nextProps.style && (!_.isEqual(this.props.style, nextProps.style))) {
            return true;
        }

        if (this.props.wordStyle !== nextProps.wordStyle &&
            (!_.isEqual(this.props.wordStyle, nextProps.wordStyle)))
        {
            return true;
        }

        if (this.props.letterStyle !== nextProps.letterStyle &&
            (!_.isEqual(this.props.letterStyle, nextProps.letterStyle)))
        {
            return true;
        }

        if (this.props.onDurationEnd !== nextProps.onDurationEnd) {
            return true;
        }

        if (this.props.onPressing !== nextProps.onPressing) {
            return true;
        }

        if (this.props.onWordPress !== nextProps.onWordPress) {
            return true;
        }

        if (this.props.onLetterPress !== nextProps.onLetterPress) {
            return true;
        }

        if (this.props.charVisible !== nextProps.charVisible) {
            return true;
        }

        if (this.props.pinyinVisible !== nextProps.pinyinVisible) {
            return true;
        }

        if (this.props.overriddenWords !== nextProps.overriddenWords &&
            (!_.isEqual(this.props.overriddenWords, nextProps.overriddenWords)))
        {
            return true;
        }

        if (this.props.overriddenLetters !== nextProps.overriddenLetters &&
            (!_.isEqual(this.props.overriddenLetters, nextProps.overriddenLetters)))
        {
            return true;
        }
        return false;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.data !== this.props.data ||
            prevProps.duration !== this.props.duration)
        {
            this.clearTimer();
            this._step = 0;
            this._length = 0;
            this.setState({step: 0, curWord: -1, curChar: -1});
            if (this.props.duration > 0) {
                this.setupTimer();
            }
        }
    }

    setupTimer() {
        if (this._timer) {
            return;
        }

        const { words } = this.props.data;
        this._startTime = Date.now();
        if (words && words.length > 0 && this.props.duration > 0) {
            this._length = 0;
            words.map((item, i) => {
                this._length += item.chars.length;
            });
            this._stepms = this.props.duration / this._length;
            this._startTime -= this._stepms;
            this._progress();
            const interval = Math.max(300, this._stepms); // 防止更新过快
            this._timer = setInterval(this._progress, interval);
        }
    }

    clearTimer() {
        if (this._timer) {
            clearInterval(this._timer);
            delete this._timer;
        }

        if (this._endTimer) {
            clearTimeout(this._endTimer);
            delete this._endTimer;
        }
    }

    _progress = () => {
        var curWord = -1;
        var curChar = -1;
        var elapsed = Date.now() - this._startTime;
        var step = parseInt(elapsed / this._stepms);
        if (this._step === step) {
            return;
        }

        this._step = step;
        if (this._step > this._length) {
            this._step = this._length;
        }

        const { words } = this.props.data;
        if (words) {
            var count = 0;
            for (var i = 0; i < words.length; ++i) {
                var n = words[i].chars.length;
                count += n;
                if (count >= this._step) {
                    curWord = i;
                    curChar = this._step - (count - n);
                    break;
                }
            }
        }

        this.setState({step: this._step, curWord, curChar});
        if (this._step >= this._length) {
            clearInterval(this._timer);
            delete this._timer;
            if (this._endTimer) {
                clearTimeout(this._endTimer);
            }
            this._endTimer = setTimeout(() => {
                delete this._endTimer;
                if (this.props.onDurationEnd) {
                    this.props.onDurationEnd();
                }
            }, 300);
        }
    }

    render() {
        let wordStyle = { ...this.props.wordStyle };

        for (var key in this.props.style) {
            if (!(key === "color" || key.indexOf("font") !== -1 || key === "lineHeight")) {
                continue;
            }

            // if this 'font' property is undefined in wordStyle, it will be added to wordStyle!
            if (!wordStyle[key]) {
                wordStyle[key] = this.props.style[key];
            }
        }

        const { words, sentenceCommand, sentenceCommandSetting } = this.props.data;
        const sentenceStyle = GetSentenceStyleBySentenceCommand(sentenceCommand, sentenceCommandSetting);

        if (_.isNumber(sentenceCommand)) {
			if (EnumHasFlag(sentenceCommand, Constants.SENTENCE_MARK_TYPE.DIALOG)) {
				const parsedSetting = ParseSetting(sentenceCommandSetting);
				if (parsedSetting && parsedSetting.role) {
					if (_.toLower(parsedSetting.role) === "a") {
						return this._renderDialog("a", words, sentenceStyle, wordStyle);
					} else if (_.toLower(parsedSetting.role) === "b") {
						return this._renderDialog("b", words, sentenceStyle, wordStyle);
					}
				}
			}
		}

        return this._renderContent(words, sentenceStyle, wordStyle);
    }

    _renderContent = (words, sentenceStyle, wordStyle) => {
        //sentence style may contains childStyleList, because the react-native do not support class like web so we need apply style manually
        let childStyleHelper = this._getChildStyleHelperFromSentenceStyle(sentenceStyle); //item in
        const allChildrenStyleFromSentence = childStyleHelper.all;
        const allCount = words ? words.length : 0;
        //filter the childStyleList
        const pureSentenceStyle = _.pickBy(sentenceStyle, (value, zKey) => zKey !== "childStyleList");

        return (
            <View style={[styles.container, pureSentenceStyle, this.props.style]}>
                {words &&
                    words.map((item, i) => {
                        let childStyleFromSentence = _.has(childStyleHelper, _.toString(i)) ? childStyleHelper[_.toString(i)] : {};
                        //for the last child case
                        if (i === allCount - 1 && _.has(childStyleHelper, "-1")) {
                            childStyleFromSentence = { ...childStyleFromSentence, ...childStyleHelper["-1"] };
                        }

                        const mergedStyle = {
                            ...allChildrenStyleFromSentence,
                            ...childStyleFromSentence,
                            ...wordStyle,
                        };
                        if (this.props.overriddenWords && this.props.overriddenWords.words && this.props.overriddenWords.renderOverriddenWord) {
                            for (let j = 0; j < this.props.overriddenWords.words.length; j++) {
                                const word = this.props.overriddenWords.words[j];
                                if (Helper.isTwoWordsSame(word, item)) {
                                    // The event here cannot be registered automatically.
                                    // Please register the corresponding event manually in the render method
                                    return this.props.overriddenWords.renderOverriddenWord(item, i); // give the i as key for array
                                }
                            }
                        }

                        var charProgress = 0;
                        if ((this.props.duration > 0) && (this.state.step > 0)) {
                            if (i < this.state.curWord) {
                                charProgress = item.chars.length;
                            }
                            else if (i === this.state.curWord) {
                                charProgress = this.state.curChar;
                            }
                        }
                        return (
                            <Word
                                key={i}
                                data={item}
                                language={this.props.language}
                                style={mergedStyle}
                                letterStyle={this.props.letterStyle}
                                syllableStyle={this.props.syllableStyle}
                                charProgress={charProgress}
                                progressColor={this.props.progressColor}
                                onPressing={this.props.onPressing}
                                onPress={this.props.onWordPress}
                                onLetterPress={this.props.onLetterPress}
                                charVisible={this.props.charVisible}
                                pinyinVisible={this.props.pinyinVisible}
                                overriddenLetters={this.props.overriddenLetters}
                                enableLearnedColor={this.props.enableLearnedColor}
                            />
                        );
                    })}
            </View>
        );
    };

    _renderDialog = (role, words, sentenceStyle, wordStyle) => {
        return (
            <View style={{flexDirection: (role === "a" ? "row" : "row-reverse"), justifyContent: "flex-start", alignItems:"center", marginVertical:10}}>
                <View style={{...(role === "a" ? {marginRight: 10} : {marginLeft: 10}), flex: 1, alignSelf: "flex-start"}}>
                    <View style={[styles.avatar, wordStyle]}><Text>{_.toUpper(role)}</Text></View>
                </View>
                <View style={{flex: 8}}>
                    {this._renderContent(words, sentenceStyle, wordStyle)}
                </View>
                <View style={{flex: 1}}></View>
            </View>
        );
    };

    /**
     * extract child style by index from sentenceStyle.childStyleList
     * @param sentenceStyle
     * @returns {Object}  // key = itemIndex, value = style list
     */
    _getChildStyleHelperFromSentenceStyle = sentenceStyle => {
        const pushForKey = (obj, key, value) => {
            if (_.isPlainObject(value)) {
                if (_.has(childStyleHelper, "0")) {
                    childStyleHelper[key] = { ...childStyleHelper[key], ...value };
                } else {
                    childStyleHelper[key] = value;
                }
            }
        };

        //sentence style may contains childStyleList, because the react-native do not support class like web so we need apply style manually
        let childStyleHelper = {}; //item in
        if (sentenceStyle && sentenceStyle.childStyleList && _.isArray(sentenceStyle.childStyleList) && sentenceStyle.childStyleList.length > 0) {
            _.each(sentenceStyle.childStyleList, (item, i) => {
                if (item.applyTo !== "") {
                    switch (item.applyTo) {
                        case "first":
                            pushForKey(childStyleHelper, "0", item.styleObj);
                            break;
                        case "last":
                            pushForKey(childStyleHelper, "-1", item.styleObj); // -1 stand for the last
                            break;
                        case "index":
                            if (_.isNumber(item.applyToIndex)) {
                                pushForKey(childStyleHelper, _.toString(item.applyToIndex), item.styleObj);
                            }
                            break;
                        case "all":
                            pushForKey(childStyleHelper, "all", item.styleObj);
                            break;
                    }
                }
            });
        }

        return childStyleHelper;
    };
}

const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "row",
    },
    avatar: {
        color: "#333",
        width: 36,
        height: 36,
        borderRadius: 36,
        backgroundColor: "#f2f2f2",
        alignItems: "center",
        justifyContent: "center",
    },
});

Sentence.propTypes = {
    data: PropTypes.object,
    duration: PropTypes.number,
    progressColor: PropTypes.string,
    onDurationEnd: PropTypes.func,
    onPressing: PropTypes.func,
    onWordPress: PropTypes.func,
    onLetterPress: PropTypes.func,
    style: PropTypes.object,
    wordStyle: PropTypes.object,
    letterStyle: PropTypes.object,
    charVisible: PropTypes.bool,
    pinyinVisible: PropTypes.bool,
    overriddenWords: PropTypes.object,
    renderOverriddenWord: PropTypes.func,
    overriddenLetters: PropTypes.object,
    renderOverriddenLetter: PropTypes.func,
    enableLearnedColor: PropTypes.bool,     //学习过的字是否变色
};

Sentence.defaultProps = {
    data: { words: [] },
    language: 'zh',
    duration: 0,
    progressColor: '',
    style: {}, // custom container style
    wordStyle: {},
    letterStyle: {},
    onDurationEnd: null,
    onPressing: null,
    onWordPress: null,
    onLetterPress: null,
    charVisible: true, // if show Chinese character
    pinyinVisible: true, // if show piyin of chinese character
    overriddenWords: { words: [{}], renderOverriddenWord: null }, // customize words' display and control
    overriddenLetters: { letters: [{}], renderOverriddenLetter: null }, // customize letters' display and control
    enableLearnedColor: true, //学习过的字是否变色
};

export default Sentence;
